import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import { brandHref } from '../utils/manifest';
import { listDirectBrandChildren } from '../utils/brandNode';

/**
 * Parent/umbrella Brand hero child links. Manifest-driven — never hardcode
 * GM/CDJR/JLR names.
 */
export default class BrandFamilyLinks extends Component {
  view() {
    const board = this.attrs.board;
    const children = listDirectBrandChildren(board);
    if (!children.length) {
      return null;
    }
    return m("nav", {
      className: "FlatRateBrandFamilyLinks",
      "aria-label": `${board.name} family boards`
    }, m("ul", {
      className: "FlatRateBrandFamilyLinks-list"
    }, children.map((child, index) => m("li", {
      className: "FlatRateBrandFamilyLinks-item",
      key: child.boardKey || child.slug
    }, index > 0 ? m("span", {
      className: "FlatRateBrandFamilyLinks-sep",
      "aria-hidden": "true"
    }, "\xB7") : null, m(Link, {
      force: true,
      className: "FlatRateBrandFamilyLinks-link",
      href: brandHref(child)
    }, child.name)))));
  }
}
flarum.reg.add('flatrate-forum-navigation', 'forum/components/BrandFamilyLinks', BrandFamilyLinks);